module.exports = __webpack_public_path__ + "static/media/k7.bfd10f35.jpg";